<template>
  <div id="app" :class="isWxMini?'clearnMaxWidth':''"  v-if="showPage" >
    <keep-alive>
      <!-- 需要缓存的视图组件 -->
      <router-view v-if="$route.meta && $route.meta.keepAlive" />
    </keep-alive>
    <router-view
      v-if="!$route.meta || !$route.meta.keepAlive"
    ></router-view>
  </div>
</template>

<script> 
    // test....
import { isMobile, judgeClientSystem, setKey, isWxMiniprogram, isTMDMiniprogram } from './assets/utils'
import { mapActions } from 'vuex'
import qs from 'qs'
export default {
  name: 'app', 
  data () {
    return {
      showPage: false,
      isWxMini: isWxMiniprogram()
    }
  },
  methods: {
    ...mapActions(['checkChannelExist'])
  },
  async created () {
    if (window.location.search) {
      const search = window.location.search
      const matchs = search.match(/channel=([^&]*)(?:$|&)/)
      const params = qs.parse(search.replace('?', ''))
      if (params.channel_mp === 'official_jsjxcx') {
        setKey('channel_mp', 'official_jsjxcx')
        setKey('terminal_jsj', 'JSJ_APPLET')
      }
      if (params.version) {
        setKey('mpVersion', params.version)
      }
      if (matchs && matchs[1]) {
        const channel = matchs[1]
        try {
          const { data } = await this.checkChannelExist({
            channelNo: channel
          })
          if (data?.exist || isTMDMiniprogram()) {
            setKey('channel', data?.exist === 'N' ? 'official_null' : channel)
          }
        } catch (e) {
          setKey('channel', channel)
        }
      }
    }
   
    this.showPage = true
   
    window.onbeforeunload = (e) => {
      localStorage.removeItem('stat_data')
      localStorage.removeItem('last_stat_ts')
    }
    if (!isMobile() && process.env.VUE_APP_ISPRODUCTION === 'true') {
      const pathRegExp = new RegExp('/landing/')
      const privacyPathRegExp = new RegExp('/protocol/privacy')
      const logonProtocol = new RegExp('/protocol/login')
      if (!(location.href.match(pathRegExp) || location.href.match(privacyPathRegExp) || location.href.match(logonProtocol))) {
        document.body.innerHTML = '请使用移动设备访问本页面'
        document.body.style.textAlign = 'center'
        this.$report({
          id: 3000,
          args: {
            target: navigator.platform
          }
        })
      }
    } else {
      // 禁止双击缩放
      if (judgeClientSystem() === 'IOS') {
        document.addEventListener('touchstart', (event) => {
          if (event.touches.length > 1) {
            event.preventDefault()
          }
        })
        let lastTouchEnd = 0
        document.addEventListener('touchend', (event) => {
          const now = (new Date()).getTime()
          if (now - lastTouchEnd <= 80) {
            event.preventDefault()
          }
          lastTouchEnd = now
        }, false)
      }
    }
    setTimeout(() => {
      this.$statistics('ENTRY')
    }, 1000)
    /** 
      * promise的错误捕获 暂不启用
      * window.addEventListener('unhandledrejection', event => {
      *   const { url } = event?.reason?.config || {}
      *   const { status, statusText } = event?.reason?.response || {}
      *   console.log('unhandledrejection', { api: url, success: false, code: status, msg: statusText })
      *   window.__bl && window.__bl.api({ api: url, success: false, code: status, msg: statusText })
      * })
     */
  }
}
</script>

<style lang="less">
@import "assets/less/mixin.less";

#app {
    font-family: 'PingFangSC-Light', 'Avenir', Helvetica, 'Microsoft Yahei',
        Arial, sans-serif;
    -webkit-font-smoothing: antialiased; // 抗锯齿渲染
    -moz-osx-font-smoothing: grayscale;
    margin: 0 auto;
    background-color: white;
    height: 100%;
    color: #333;
    position: relative;
    max-width: 750px;
}
.clearnMaxWidth{
  max-width: none;
}
</style>
